/* ============================================================
 * MasterKey ─ スクロール出現アニメーション(Apple 風・下からふわっ)
 *   ・#main 内の見出し/本文/ボタン/画像/カードを対象に、
 *     ビューポートに入ったら opacity + translateY で出現させる。
 *   ・テーマ(Prestige)標準の reveal-on-scroll と重複しないよう、
 *     [reveal-on-scroll] 配下は対象外。
 *   ・ヒーロー(slideshow)・ヘッダー・フッター・ダイアログ類は対象外。
 *   ・prefers-reduced-motion では何もしない(アクセシビリティ)。
 * ============================================================ */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var TARGETS = 'h1, h2, h3, .h1, .h2, .h3, p, .button, .product-card, .blog-post-card, img, video-media';
  var EXCLUDE_CLOSEST = [
    '[reveal-on-scroll]',            // テーマ標準のアニメーション対象
    '.shopify-section--slideshow',   // ヒーロー動画は即時表示
    '.shopify-section--header',
    '[role="dialog"]',
    'dialog',
    '.cart-drawer',
    '.quick-buy-drawer',
    '[aria-hidden="true"]'
  ].join(',');

  var pending = [];   // まだ出現していない要素

  function show(el) {
    el.classList.add('mk-reveal-in');
    observer.unobserve(el);
    var i = pending.indexOf(el);
    if (i !== -1) pending.splice(i, 1);
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) show(entry.target);
    });
  }, { threshold: 0.05, rootMargin: '0px 0px -8% 0px' });

  // IntersectionObserver は「一気に通り過ぎた要素」を検知できないことがある
  // (高速スクロール・アンカージャンプ)。スクロール毎に取りこぼしを拾う。
  var sweepScheduled = false;
  function sweep() {
    sweepScheduled = false;
    if (!pending.length) return;
    var line = window.innerHeight * 0.92;
    for (var i = pending.length - 1; i >= 0; i--) {
      if (pending[i].getBoundingClientRect().top < line) show(pending[i]);
    }
  }
  function requestSweep() {
    if (!sweepScheduled) {
      sweepScheduled = true;
      requestAnimationFrame(sweep);
    }
  }
  window.addEventListener('scroll', requestSweep, { passive: true });
  window.addEventListener('resize', requestSweep, { passive: true });

  function collect(root) {
    var candidates = Array.prototype.slice.call(root.querySelectorAll(TARGETS));
    var kept = [];
    candidates.forEach(function (el) {
      if (el.classList.contains('mk-reveal')) return;
      if (el.closest(EXCLUDE_CLOSEST)) return;
      // 祖先がすでに対象なら子は動かさない(二重アニメーション防止)
      for (var i = 0; i < kept.length; i++) {
        if (kept[i].contains(el)) return;
      }
      kept.push(el);
    });
    return kept;
  }

  function process(sectionRoot) {
    var els = collect(sectionRoot);
    var columns = sectionRoot.querySelectorAll('.multi-column__item');
    var columnCounts = [];
    var flowIndex = 0;

    els.forEach(function (el) {
      el.classList.add('mk-reveal');

      // 時間差(Apple 風の「順に立ち上がる」感)
      //  ・multi-column(TOP 3本柱 等)はカラム単位で 1 枚ずつ:
      //    カラム順 × 150ms + カラム内 × 80ms
      //  ・それ以外はセクション内の登場順 × 70ms(最大 350ms)
      var delay;
      var col = el.closest('.multi-column__item');
      if (col && columns.length) {
        var colIdx = Array.prototype.indexOf.call(columns, col);
        var inner = columnCounts[colIdx] || 0;
        columnCounts[colIdx] = inner + 1;
        delay = Math.min(colIdx * 150 + inner * 80, 700);
      } else {
        delay = Math.min(flowIndex * 70, 350);
        flowIndex++;
      }
      el.style.setProperty('--mk-reveal-delay', delay + 'ms');

      pending.push(el);
      observer.observe(el);
    });
    requestSweep();
  }

  function init() {
    var main = document.getElementById('main');
    if (!main) return;
    var sections = main.querySelectorAll('.shopify-section');
    if (sections.length) {
      sections.forEach(process);
    } else {
      process(main);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // テーマエディタでセクションが再描画された時も適用
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) process(e.target);
  });
})();
